var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLaboratories(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_13258)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5 15.75C10.5 16.5456 10.1839 17.3087 9.62132 17.8713C9.05871 18.4339 8.29565 18.75 7.5 18.75C6.70435 18.75 5.94129 18.4339 5.37868 17.8713C4.81607 17.3087 4.5 16.5456 4.5 15.75V0.75H10.5V15.75Z",
    stroke: "#FAFAFA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5 15.75C19.5 16.5456 19.1839 17.3087 18.6213 17.8713C18.0587 18.4339 17.2956 18.75 16.5 18.75C15.7044 18.75 14.9413 18.4339 14.3787 17.8713C13.8161 17.3087 13.5 16.5456 13.5 15.75V0.75H19.5V15.75Z",
    stroke: "#FAFAFA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5 10.5V20.25C22.5 21.0456 22.1839 21.8087 21.6213 22.3713C21.0587 22.9339 20.2956 23.25 19.5 23.25H4.5C3.70435 23.25 2.94129 22.9339 2.37868 22.3713C1.81607 21.8087 1.5 21.0456 1.5 20.25V10.5",
    stroke: "#FAFAFA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.5 14.25H4.5",
    stroke: "#FAFAFA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 14.25H13.5",
    stroke: "#FAFAFA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5 14.25H22.5",
    stroke: "#FAFAFA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.5 6.75H10.5",
    stroke: "#FAFAFA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 6.75H19.5",
    stroke: "#FAFAFA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.875 10.5C7.66789 10.5 7.5 10.3321 7.5 10.125C7.5 9.91789 7.66789 9.75 7.875 9.75",
    stroke: "#FAFAFA",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.875 10.5C8.08211 10.5 8.25 10.3321 8.25 10.125C8.25 9.91789 8.08211 9.75 7.875 9.75",
    stroke: "#FAFAFA",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.125 10.5C15.9179 10.5 15.75 10.3321 15.75 10.125C15.75 9.91789 15.9179 9.75 16.125 9.75",
    stroke: "#FAFAFA",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.125 10.5C16.3321 10.5 16.5 10.3321 16.5 10.125C16.5 9.91789 16.3321 9.75 16.125 9.75",
    stroke: "#FAFAFA",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.875 14.25C16.6679 14.25 16.5 14.0821 16.5 13.875C16.5 13.6679 16.6679 13.5 16.875 13.5",
    stroke: "#FAFAFA",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.875 14.25C17.0821 14.25 17.25 14.0821 17.25 13.875C17.25 13.6679 17.0821 13.5 16.875 13.5",
    stroke: "#FAFAFA",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.125 14.25C6.91789 14.25 6.75 14.0821 6.75 13.875C6.75 13.6679 6.91789 13.5 7.125 13.5",
    stroke: "#FAFAFA",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.125 14.25C7.33211 14.25 7.5 14.0821 7.5 13.875C7.5 13.6679 7.33211 13.5 7.125 13.5",
    stroke: "#FAFAFA",
    strokeWidth: 1.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_13258"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaboratories);
export default __webpack_public_path__ + "static/media/Laboratories.8c10261d57fa1b3ff813361ab8053ed4.svg";
export { ForwardRef as ReactComponent };